module.exports = __webpack_public_path__ + "img/3-8-west-vvip.4bc6c41a.jpg";